<div class="page">
    <div class="page-title" *ngIf="page.mostrar_titulo">
        <div class="container">
            <h1 class="wow slideInDown" data-wow-delay="0.7s">{{page.titulo}}</h1>
            <h2 class="wow slideInUp" *ngIf="page.mostrar_subtitulo">{{page.subtitulo}}</h2> 
            <div class="logo wow fadeIn" data-wow-delay="0.5s">
                <img class="animated infinite pulse" src="/images/conteudo/logo/{{params.logo}}" alt="Logo - Greenhouse School" width="200px" />
            </div>
        </div>
    </div>
    <div class="page-content">
        <div class="section section-description">
            <div class="container">
                <article class="wow fadeIn" data-wow-delay="0.5s" [innerHtml]="page.texto | safeHtml"></article>
            </div>
            <div class="logo-simbolo wow slideInLeft" data-wow-delay="0.5s">
                <img src="/images/logo/simbolo.svg"  alt="Greenhouse School" width="200px" />
            </div>
        </div>
        <div class="section section-instagram">
            <div class="section-title">
                <div class="container">
                    <h2 class="wow slideInDown">Nos acompanhe no instagram</h2>
                </div>
            </div>
            <div class="section-content">    
                <div class="container">
                    <div class="instagram-conta">
                        <a [href]="params.instagram_link" alt="Instagram Greenhouse School" target="_blank">
                            {{params.instagram_conta}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="section section-help">
            <div class="section-title">
                <div class="container">
                    <h2 class="wow slideInDown">Entre em contato para mais informações</h2>
                </div>
            </div>
            <div class="section-content">
                <div class="content-whatsapp">
                    <modulo class="wow slideInRight" data-wow-delay="0.5s" posicao="whatsapp" template="greenhouse-school"></modulo>
                </div>
            </div>
        </div>
    </div>    
</div>    
<loader *ngIf="loader"></loader>